<template>
  <div class="tContent">
      <div class="fRow">
         <table>
          <tr>
            <td rowspan="2" class="sTtile">មុខវិជ្ជា</td>
            <td rowspan="2" class="sTtile">ភេទ</td>
            <td colspan="11" style="text-align:center;background-color: #f8f8f8;font-weight: bold;">
              ចំនួនសិស្សស្រី ប្រុសតាមកម្រិតពន្ទុនិងមុខវិជ្ជា
            </td>
            <td rowspan="2" class="colTotal">សរុប</td>
            <td rowspan="2" style="width:50px;text-align:center; background-color: #f8f8f8;font-weight: bold;">
              សរុប សិស្សជាប់
            </td>
          </tr>
          <tr>
            <td class="colHeader">0</td>
            <td class="colHeader">1</td>
            <td class="colHeader">2</td>
            <td class="colHeader">3</td>
            <td class="colHeader">4</td>
            <td class="colHeader">5</td>
            <td class="colHeader">6</td>
            <td class="colHeader">7</td>
            <td class="colHeader">8</td>
            <td class="colHeader">9</td>
            <td class="colHeader">10</td>
          </tr>
        </table> 
      </div>
    <div class="sRow">
      <div>
        <v-container class="cont">
          <table>
            <tr><td rowspan="2" class="sTtile">ភាសាខ្មែរ</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">គណិតវិទ្យា</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">សិក្សាសង្គម</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
            <tr><td rowspan="2" class="sTtile">វិទ្យាសាស្ត្រ</td><td class="gender">ស្រី</td></tr>
            <tr><td class="gender">ប្រុស</td></tr>
          </table>
        </v-container>      
      </div>
      <div>
        <v-container class="contD">
          <v-slide-y-transition mode="out-in">
            <v-layout column align-center>
              <score-by-Subject :dataRow="scoreData[0]" :dataDisable="apCon[0]" :endCol="eCol"></score-by-Subject> <!--Subject 1-->
              <score-by-Subject :dataRow="scoreData[1]" :dataDisable="apCon[1]" :endCol="eCol"></score-by-Subject> <!--Subject 2-->
              <score-by-Subject :dataRow="scoreData[2]" :dataDisable="apCon[2]" :endCol="eCol"></score-by-Subject> <!--Subject 3-->
              <score-by-Subject :dataRow="scoreData[3]" :dataDisable="apCon[3]" :endCol="eCol"></score-by-Subject> <!--Subject 4-->
            </v-layout>
          </v-slide-y-transition>
        </v-container>
      </div>
      <div>
        <v-container>
        </v-container> 
      </div>
    </div>
  </div>
</template>

<script>

import ScoreBySubject from './ScorebySubject.vue'
import apCon from '@/utils/appConfig'
import { grade16, qemissubject } from '@/utils/prischool.js'

export default {
  name: 'Grade16',
  props: ['scoreData'],
  components: {
    'scoreBySubject': ScoreBySubject
  },
  data () {
    return {
      apCon: apCon.qemisPriDisable,
      eCol: 2,
      g16: grade16,
      qsub: qemissubject
    }
  }
}
</script>

<style scoped>
  .tContent {
    display: flex;
    flex-direction: column;
    width: 1000px;   
  }
  .fRow {
    display: flex;
    align-content: flex-start;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }
  .sRow {
    display: flex;
  }
  .sTtile {
    width: 100px;
    height: 60px;
    text-align: center;
    font-weight: bold;
    background-color: #f8f8f8;
  }
  .gender {
    width: 100px;
    text-align: center;
    background-color: #f8f8f8;
    font-weight: bold;
  }
  .colHeader {
    font-size: 12px;
    width: 50px;
    text-align: center;
    background-color: #f8f8f8;
    font-weight: bold;
  }
  .colTotal {
    text-align: center;
    width: 60px;
    font-weight: bold;
  }
  .cont {
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }
  .contD {
    padding-top: 2px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 2px;
  }
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    text-align: left;    
  }
</style>
